import React from "react";
import AboutSection from "../components/aboutSection";
import Contact from "../components/contactSection";

function About() {
  return (
    <div className="w-full bg-Darkbg flex flex-col BGabout">
      <div className="relative">
        <AboutSection />
        <Contact />
      </div>
    </div>
  );
}

export default About;
